import { createSelector } from 'reselect'
import { AnyObject } from '../../types/common'
import { AppState } from '../types'

export const selectPrint = createSelector(
  (state: AppState) => state.print,
  (data: AnyObject) => data
)
